import React from 'react'
import HomeLinksPage from '../components/Home/HomeLinksPage';
import { useSelector } from 'react-redux';
import { State } from '../redux/store';
import HomeLinksDoctor from '../components/Home/HomeLinksDoctor';

const HomePage:React.FC = () => {
  
  const { userData } = useSelector((state: State) => state.login)

  return (
    <div className='mt-20'>
      {userData.user && <HomeLinksPage />}
      {userData.doctor && <HomeLinksDoctor />}
    </div>
  )
}

export default HomePage
